import { CompletionLengthEnum } from '../../../api/ai/enums/completion-length.enum';
import { DropdownOptionModel } from '../models/dropdown-option.model';

export const promptLengthOptions: DropdownOptionModel[] = [
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.veryShort', CompletionLengthEnum.VERY_SHORT),
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.short', CompletionLengthEnum.SHORT),
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.average', CompletionLengthEnum.MEDIUM),
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.long', CompletionLengthEnum.LONG),
];

export const sentimentOpinionLengthOptions: DropdownOptionModel<CompletionLengthEnum>[] = [
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.short', CompletionLengthEnum.SHORT),
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.medium', CompletionLengthEnum.MEDIUM),
    new DropdownOptionModel('Common.dialog.aiHelper.pressReleaseLength.long', CompletionLengthEnum.LONG),
];
